import React from "react";

import { SearchInput } from "@common/components/SearchInput/SearchInput";
import { ActivityHistoryFilter } from "@main/pages/shared/consumers/useActivityHistoryFilter";
import {
  ConsoleLogsFilterIcon,
  CustomLogsFilterIcon,
  NotificationEventsFilterIcon,
  ScreenViewsFilterIcon,
  SystemEventsFilterIcon,
  UserActionsFilterIcon,
} from "@main/pages/shared/icons/icons";
import * as Styled from "@public/pages/shared/components/ActivityHistoryTable/SearchAndFilter/ActivityHistoryFilterView.styles";
import { FilterButton } from "@public/pages/shared/components/ActivityHistoryTable/SearchAndFilter/FilterButton";
import { NetworkFilter } from "@public/pages/shared/components/ActivityHistoryTable/SearchAndFilter/NetworkFilter";

const filterButtonConfigs: {
  key: keyof Pick<
    ActivityHistoryFilter,
    "consoleLogs" | "systemEvents" | "customLogs" | "screenViews" | "userActions" | "notificationEvents"
  >;
  title: string;
  icon: React.ReactNode;
}[] = [
  { key: "consoleLogs", title: "Console logs", icon: <ConsoleLogsFilterIcon /> },
  { key: "systemEvents", title: "System events", icon: <SystemEventsFilterIcon /> },
  { key: "userActions", title: "User actions", icon: <UserActionsFilterIcon /> },
  { key: "screenViews", title: "Screen views", icon: <ScreenViewsFilterIcon /> },
  { key: "notificationEvents", title: "Notification events", icon: <NotificationEventsFilterIcon /> },
  { key: "customLogs", title: "Custom logs", icon: <CustomLogsFilterIcon /> },
];

interface ActivityHistoryFilterProps {
  filter: ActivityHistoryFilter;
  setFilter: (filter: ActivityHistoryFilter) => void;
}

const ActivityHistoryFilterView = ({ filter, setFilter }: ActivityHistoryFilterProps) => {
  const handleToggle = (key: keyof ActivityHistoryFilter) => {
    setFilter({ ...filter, [key]: !filter[key] });
  };
  return (
    <Styled.ActivityHistoryFilter>
      <SearchInput
        value={filter.searchText}
        onChanged={(text) => setFilter({ ...filter, searchText: text })}
      />
      <NetworkFilter
        setFilter={setFilter}
        filter={filter}
      />
      {filterButtonConfigs.map(({ key, title, icon }) => (
        <FilterButton
          key={key}
          title={title}
          isActive={filter[key]}
          onClick={() => handleToggle(key)}
          icon={icon}
        />
      ))}
    </Styled.ActivityHistoryFilter>
  );
};

export { ActivityHistoryFilterView };
